import { render } from "./CrownIcon.vue?vue&type=template&id=0c428809"
const script = {}
script.render = render

export default script